import React, { useCallback, useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import reactStringReplace from 'react-string-replace'
import * as Icons from "react-feather";
import DealerModel from './models/DealerModel';
import AddDealer from './AddDealer';
import EditDealer from './EditDealer';
import ViewDealer from './ViewDealer';
import DeleteDealer from './DeleteDealer';
import { logAuditEvent } from '../../utils/auditLogger';

function DealerModal({onClose, onSubmit, UserAction, show, selectedRow, moduleName}) {
    const [childData, setChildData] = useState(new DealerModel() || []);
    let modalAction;
    let showButtons;
    let userAction = reactStringReplace(UserAction, 'User', () => '');

    useEffect(() => {
                if (show && selectedRow) {
                    setChildData({ ...selectedRow }); // create a new object to break reference
                } else if (!show) {
                    setChildData(new DealerModel()); // reset when closed
        }
    }, [selectedRow, show]);

    const handleDataFromChild = useCallback((data) => {
        setChildData(data);
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(e, childData);  // Send the form data back to the parent component
    };

    const handleCancel = (label) => {
        logAuditEvent(moduleName, `${UserAction || 'Action'} ${label}`, `${label} clicked`)
        onClose()
     };

    const handleLoad = useCallback((data) => {
        setChildData(data); // Send the form data back to the parent component
    }, []);
    if(UserAction === "Add"){
        modalAction = <AddDealer  isOpen={show} onLoad= {handleLoad} sendDataToParent={handleDataFromChild}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Add" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="Add" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "Edit"){
        modalAction = <EditDealer DealerData={childData} onSubmit= {onSubmit} sendDataToParent={handleDataFromChild}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Edit" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="Edit" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "View"){
        modalAction = <ViewDealer DealerData={selectedRow}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="View" onClick={onClose}>Cancel</button>
                    </div>
    } else if(UserAction === "Delete"){
        modalAction = <DeleteDealer DealerData={selectedRow}/>
        showButtons = <div>
                            <button className="btn btn-sm btn-secondary m-1" name="Delete" onClick={onClose}>Cancel</button>
                            <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit}>Delete</button>
                    </div>
    }
  return (
    UserAction !== "Delete" ?
            <Modal
                show={show}
                onHide={onClose}
                backdrop="static"
                dialogClassName="modal-dialog-centered stock-adjust-modal" 
            >
                <ModalHeader className="modal-header border-0 custom-modal-header">
                    <ModalTitle >{userAction +" "+ moduleName} </ModalTitle>
                     <button type="button" className="close" aria-label="Close" onClick={() => handleCancel('Close')}>
                        <span aria-hidden="true">×</span>
                    </button>
                </ModalHeader>
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="">
                    {showButtons}
                </ModalFooter>
            </Modal> 
        :   <Modal
                show={show}
                onHide={onClose}
                backdrop="static"            >
           
                <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
                    <ModalTitle>
                        <div className="custom-alert-icon">
                            <Icons.AlertOctagon className="flex-shrink-0"/>
                        </div>
                        <div > {userAction} Dealer</div>
                    </ModalTitle>
                </ModalHeader>
                
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="modalfooter-width">
                    {showButtons}
                </ModalFooter>
            </Modal>  
  )
}

export default DealerModal